import React from "react";
import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * ConfirmMergeDialog — non-destructive merge confirmation for the
 * species-mode flow. Copy explains how many rows will collapse into
 * the primary and preserves the plant's display name.
 */
export default function ConfirmMergeDialog({ pending, onCancel, onConfirm }) {
  const { t } = useTranslation();
  return (
    <AlertDialog open={!!pending} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display" data-testid="dup-merge-confirm-title">
            {t("duplicates.mergeConfirmTitle")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t("duplicates.mergeConfirmDesc", {
              total: pending?.total || 0,
              name: pending?.label || t("gallery.card.unknown"),
            })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="dup-merge-cancel">
            {t("common.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="dup-merge-confirm"
            onClick={(e) => { e.preventDefault(); onConfirm(); }}
            className="bg-leaf hover:bg-leaf-deep"
          >
            {t("duplicates.mergeAction")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
